import React from 'react';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';
import Tooltip from 'core/tools/Tooltip';

//STYLES
import styles from './dmstooltip.module.scss';

const DmsTooltip = () => {
  return (
    <Tooltip className={styles.tooltip} tip="DMS Sync Occurs every 3 hours.">
      <Sprite className={styles.info} use="info" fill="primary-extra-light" size='xs' />
    </Tooltip>
  );
};

export default DmsTooltip